import axiosInstance from "./AxiosInstance";

export const getWeeklyTracker = async () => {
  try {
    const response = await axiosInstance.get("api/weekly-tracking/progress");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching progress:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const getGraphDetails = async (data) => {
  try {
    const response = await axiosInstance.get("api/weekly-tracking/graph", {
      params: {
        week_range: data,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchLifestyleWellnessData = async (weekRange) => {
  try {
    const response = await axiosInstance.get(
      "api/weekly-tracking/lifestyle-wellness",
      {
        params: {
          week_range: weekRange,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchStepsData = async (data) => {
  try {
    const response = await axiosInstance.get("api/fitness-summary/saved", {
      params: data,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const WeeklyCheckIn = async () => {
  try {
    const getSystemTimezone = () => {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };
    const response = await axiosInstance.get("api/fitness/summary", {
      params: { is_weekly_check_in: true, time_zone: getSystemTimezone() },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const submitUnit = async (data) => {
  try {
    const response = await axiosInstance.put("api/weekly-tracking/unit", {
      physical_trans_unit: data,
    });
    return response.data;
  } catch (error) {
    console.error("Error in submitting unit:", error);
    throw error;
  }
};

export const fetchWeeklyRanks = async () => {
  try {
    const response = await axiosInstance.get("api/weekly-tracking/rank");
    return response.data;
  } catch (error) {
    console.error("Error fetching ranks:", error);
    throw error;
  }
};
